import { render } from "./StatuSettings.vue?vue&type=template&id=5f8fa548&scoped=true&ts=true"
import script from "./StatuSettings.vue?vue&type=script&lang=ts"
export * from "./StatuSettings.vue?vue&type=script&lang=ts"

import "./StatuSettings.vue?vue&type=style&index=0&id=5f8fa548&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5f8fa548"]])

export default __exports__